export default {
    URL_API: "https://apisgt.devtrimap.com.br/api",
    URL_API_REPORTS: "https://apirelatorios.devtrimap.com.br/api"
}

